import ObjectBuilderInterface from "@/modules/api/object-builder.interface";
import ApiCollectionResponseParserService from "@/modules/api/api-collection-response-parser.service";
import ApiService from "@/modules/api/api.service";
import BasicRepository from "@/modules/api/basic.repository";

import PlushieUpgradeRelation from "./plushie-upgrade-relation.model";

export default class PlushieUpgradeRelationRepository extends BasicRepository<PlushieUpgradeRelation> {
  constructor(
    api: ApiService,
    objectBuilder: ObjectBuilderInterface<PlushieUpgradeRelation>,
    responseParser: ApiCollectionResponseParserService<PlushieUpgradeRelation>
  ) {
    super("plushie_upgrade_relations", api, objectBuilder, responseParser);
  }

  public async getByPlushieId(
    plushieId: string
  ): Promise<PlushieUpgradeRelation[]> {
    const collection = await this.fetchList({ plushie: plushieId });

    return collection.getItems();
  }

  public async getByPlushieIds(
    plushieIds: string[]
  ): Promise<PlushieUpgradeRelation[]> {
    const collection = await this.fetchList({ plushie: plushieIds });

    return collection.getItems();
  }

  protected prepareData(
    item: PlushieUpgradeRelation
  ): Record<string, string | number> {
    const data: Record<string, string> = {
      id: item.id,
      plushie: item.plushie,
      upgrade: item.upgrade,
    };

    return data;
  }
}
